import React from "react";

interface Props {
  activeColor: string;
}
const IconUserManagement: React.FC<Props> = ({ activeColor = "#0f1560" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12Z"
        fill={activeColor}
        stroke={activeColor}
      />
      <path
        d="M4 20C4 16.69 7.58 14 12 14C16.42 14 20 16.69 20 20V21H4V20Z"
        fill={activeColor}
        stroke={activeColor}
      />
      <path
        d="M18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2"
        fill={activeColor}
        stroke={activeColor}
      />
      <path
        d="M21 21V20C21 17.79 19.21 16 17 16"
        fill={activeColor}
        stroke={activeColor}
      />
    </svg>
  );
};

export default IconUserManagement;
